module.exports = __webpack_public_path__ + "static/media/blogTwo.b2f024eb.jpg";